import { bankRecDateParams } from "@/views/BankReconciliation/BankRec/dates";
/* eslint-disable */
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Modal, Button, message, Flex } from "antd";
import dayjs from "dayjs";
import http from "@/utils/http";
import api from "@/utils/api";
import EnhancedTable from "@/hocComponents/EnhancedTable";
import { EditOutlined, BankOutlined } from "@ant-design/icons";

export default function CTModal({
  open,
  onClose,
  record,
  reconcileDateSt,
  onSuccess,
}) {
  const [submitLoading, setSubmitLoading] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const [transList, setTransList] = useState([]);
  const [selectedTransIds, setSelectedTransIds] = useState([]);
  const [selectedTransRows, setSelectedTransRows] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 25,
    total: 0,
  });
  // 搜索条件 state
  const [filters, setFilters] = useState({});

  const initTableHead = {};
  const bankId = useMemo(
    () => record?.bankInfo?.bankId || record?.bankId,
    [record],
  );
  const trustId = useMemo(
    () => record?.bankInfo?.trustId || record?.trustId,
    [record],
  );

  const resetState = () => {
    setTransList([]);
    setSelectedTransIds([]);
    setSelectedTransRows([]);
    setSubmitLoading(false);
    setTableLoading(false);
    setPagination({ current: 1, pageSize: 25, total: 0 });
    setFilters({});
  };
  const handleSubmit = () => {
    if (!reconcileDateSt) {
      return message.warning("Please select a clear date first.");
    }

    if (!selectedTransRows.length) {
      return message.warning("Please select at least one transaction.");
    }

    Modal.confirm({
      title: "Confirm Clear",
      content: `You are about to clear ${selectedTransRows.length} transaction(s).`,
      okText: "Confirm",
      cancelText: "Close",
      centered: true,
       onOk: doSubmit,
    });
  };
const doSubmit = async () => {
  setSubmitLoading(true);

  try {
    const matchId = selectedTransRows
      .map(row => row.matchId)
      .join(",");
  const { bankId, glAcct, trust } = selectedTransRows[0];
    const params = {
      matchId,
      bankId,
      glAcct,
      trust,
      reconcileDateSt,
    };
    const res = await http.get(api.getUnreconcileTrans, { params: bankRecDateParams(params) });
    if (res?.code !== "1") {
      message.error(res?.msg || "Clear failed.");
      throw new Error("Clear failed"); 
    }
    message.success("Cleared successfully.");
    await fetchTableData(
      pagination.current,
      pagination.pageSize,
      filters
    );

    setSelectedTransIds([]);
    setSelectedTransRows([]);
     onSuccess && onSuccess();
    return true;
  } catch (e) {
    message.error(e?.message || "Clear failed.");
    throw e;
  } finally {
    setSubmitLoading(false);
  }
};

  const handleFilterChange = (key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  };
  const handleFilterSubmit = (nextFilters) => {
    setFilters(nextFilters || {});
    fetchTableData(1, pagination.pageSize, nextFilters);
  };

  const handlePageChange = (page, pageSize) => {
    fetchTableData(page, pageSize, filters);
  };

  const handlePageSizeChange = (_current, size) => {
    fetchTableData(1, size, filters);
  };

  const fetchTableData = async (page = 1, count = 25, searchFilters = {}) => {
    if (!open || !record || !bankId) return;
    setTableLoading(true);

    const params = { page, count, bankId, ...searchFilters };

    try {
      const response = await http.get(api.getClearedTrans, { params: bankRecDateParams(params) });
      const list = (response?.data?.list || response?.data || []).map(
        (item, index) => ({
          ...item,
          "#": (params.page - 1) * params.count + index + 1,
        }),
      );

      setTransList(list);
      setPagination({
        total: response?.data?.total || 0,
        current: page,
        pageSize: count,
      });
    } catch (e) {
      message.error(e?.message || "Failed to load cleared transactions.");
    } finally {
      setTableLoading(false);
    }
  };

  const clearedColumns = [
    { title: "#", dataIndex: "#", width: 50 },
    {
      title: "Trans Type",
      dataIndex: "type",
      filterKey: "type",
      filterType: "select",
      selectOptions: [
        { value: "Book Trans", label: "Book Trans" },
        { value: "Bank Trans", label: "Bank Trans" },
      ],
      render: (text) => {
        let color =
          text === "Book Trans"
            ? "green"
            : text === "Bank Trans"
              ? "red"
              : "black";
        return (
          <span style={{ color }}>
            <BankOutlined /> {text}
          </span>
        );
      },
    },
    {
      title: "Match Id",
      dataIndex: "matchId",
      filterKey: "matchId",
      filterType: "input",
    },

    {
      title: "Cleared Date",
      dataIndex: "clearedDate",
      titleType: "DatePicker",
      isSorter: false,
      format: "MM/DD/YYYY",
      filterKey: "clearedDate",
      filterType: "date",
      render: (value) => {
        if (!value) return " ";
        return dayjs(value).format("MM/DD/YYYY");
      },
    },
    {
      title: "Trans Date",
      dataIndex: "date1",
      titleType: "DatePicker",
      isSorter: false,
      format: "MM/DD/YYYY",
      filterKey: "date1",
      filterType: "date",
      render: (value) => {
        if (!value) return " ";
        return dayjs(value).format("MM/DD/YYYY");
      },
    },
    {
      title: "Check #",
      dataIndex: "checkNo",
      filterKey: "checkNo",
      filterType: "input",
    },
    {
      title: "Batch",
      dataIndex: "batch",
      filterKey: "batch",
      filterType: "input",
    },
    {
      title: "Prop",
      dataIndex: "prop",
      filterKey: "prop",
      filterType: "input",
    },
    {
      title: "Amount",
      dataIndex: "amountRow",
      filterKey: "amountRow",
      filterType: "input",
    },
    {
      title: "Journal",
      dataIndex: "journal",
      filterKey: "journal",
      filterType: "input",
    },
    {
      title: "Cleared By",
      dataIndex: "usid",
      filterKey: "usid",
      filterType: "input",
    },
    {
      title: "Remark",
      dataIndex: "remark",
      filterKey: "remark",
      filterType: "input",
    },
  ];

  useEffect(() => {
    if (open && record && bankId) {
      fetchTableData(1, pagination.pageSize, filters);
    } else if (!open) {
      resetState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, record, bankId]);

  return (
    <Modal
      width="80%"
      open={open}
      onCancel={onClose}
      afterClose={resetState}
      maskClosable={false}
      footer={
           <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button key="close" danger onClick={onClose}>
          Close
        </Button></div>}
      title={
        <div style={{ fontSize: 18, fontWeight: "bold", color: "#E55353" }}>
          <EditOutlined style={{ marginRight: 10 }} />
          VIEWING UNRECONCILED TRANSACTIONS FOR TRUST: {
            record?.bankInfo?.trust
          }{" "}
          | BANK: {record?.bankInfo?.bank} | GL: {record?.bankInfo?.glAcct} |
          CR: {record?.bankInfo?.crAcct} | CP: {record?.bankInfo?.cpAcct} |
          CLEAR DATE:{" "}
          {reconcileDateSt ? dayjs(reconcileDateSt).format("MM/DD/YYYY") : ""}
        </div>
      }
    >
      <Flex justify="space-between" align="flex-start">
        <div style={{ width: "100%" }} className="model_top">
          <div
            style={{
              marginTop: 10,
              display: "flex",
              alignItems: "center",
              gap: 12,
            }}
          >
            <Button
              type="primary"
              onClick={handleSubmit}
              loading={submitLoading}
              disabled={!selectedTransRows.length}
              style={{ marginBottom: 10 }}
            >
              Unreconciled Trans
            </Button>
          </div>

          <EnhancedTable
            rowKey="id"
            loading={tableLoading}
            columns={clearedColumns}
            dataSource={transList}
            pagination={{
              ...pagination,
              showTotal: (total) => `Total: ${total}`,
              showSizeChanger: true,
              showQuickJumper: true,
              onChange: handlePageChange,
              onShowSizeChange: handlePageSizeChange,
            }}
            scroll={{ y: "calc(100vh - 350px)" }}
            filters={filters}
            onFilterChange={handleFilterChange}
            onFilterSubmit={handleFilterSubmit}
            rowSelection={{
              type: "checkbox",
              selectedRowKeys: selectedTransIds,
              onChange: (keys, rows) => {
                setSelectedTransIds(keys);
                setSelectedTransRows(rows);
              },
            }}
          />
        </div>
      </Flex>
    </Modal>
  );
}
